'use client';

import { useQuery } from '@tanstack/react-query';

// Bot API response (single bot without stats)
export interface BotData {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  status: 'draft' | 'published' | 'suspended';
  primaryLanguage: string;
  visibility: 'public' | 'unlisted';
  welcomeMessage: string | null;
  deactivatedAt: string | null;
  isActive: boolean;
  intakeEnabled: boolean;
  intakeCompletionMessage: string | null;
  intakePromptMessage: string | null;
  /** Story 7.9: when false, consumers see no suggested-question chips. */
  suggestedQuestionsEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

interface BotResponse {
  data: BotData;
}

async function fetchBot(botId: string): Promise<BotResponse> {
  const res = await fetch(`/api/bots/${botId}`);

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error?.error?.message || 'Failed to fetch bot');
  }

  return res.json();
}

export function useBot(botId: string | null) {
  return useQuery({
    queryKey: ['bot', botId],
    queryFn: () => fetchBot(botId!),
    enabled: !!botId,
    staleTime: 30 * 1000, // 30 seconds
  });
}
